module.exports = __webpack_public_path__ + "static/media/trains_icon.1701e5d8.svg";